export default __webpack_public_path__ + "static/media/38-TPG.b91279e7.jpg";